import { load } from '../util/util';

const faRoot = 'https://static.empori.se/fa/css/';

const faFiles = [
  `${faRoot}fontawesome.min.css`,
  `${faRoot}regular.min.css`,
  `${faRoot}brands.min.css`
];

// let faLoaded = false;

export function loadFontAwesomePro(parentElement?: Node | null) {
  faFiles.forEach(file => load('link', { href: file, rel: 'stylesheet' }, parentElement ?? document.head));
}

/** @deprecated Not needed anymore, this is loaded automatically for all web components. */
export function InitFontAwesome() {
  // if (faLoaded) {
  //   return;
  // }
  //
  // const links = document.getElementsByTagName('link');
  //
  // for (let i = links.length; i--;) {
  //   if (faFiles.some(link => link === links[i].href)) {
  //     faLoaded = true;
  //     return;
  //   }
  // }
  //
  // loadFontAwesomePro();
  // faLoaded = true;
}